import getApiClient from "./../../../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications,
  showWarning
} from "../../../../../notifications/ducks/actions";

const url = "/film";

export const FETCH_COSTUME_OVERVIEW = "FETCH_COSTUME_OVERVIEW";
export const SAVE_ALIAS_COSTUME = "SAVE_ALIAS_COSTUME";
export const SAVE_UNALIAS_COSTUME = "SAVE_UNALIAS_COSTUME";
export const DELETE_MULTIPLE_COSTUMES = "DELETE_MULTIPLE_COSTUMES";

export function fetchCostumeOverview(id) {
  return (dispatch) => {
    dispatch({
      type: FETCH_COSTUME_OVERVIEW,
      payload: getApiClient().get(`${url}/${id}/Costume/Overview`)
    });
  };
}

export function aliasCostume(filmId, aliasCostume, preferredCostume) {

  return (dispatch) => {
    dispatch({
      type: SAVE_ALIAS_COSTUME,
      payload: getApiClient().put(
        `${url}/${filmId}/Costume/${preferredCostume.id}/Alias`,
        { aliasId: aliasCostume.id }),
      meta: { aliasCostume, preferredCostume }
    })
      .then((response) => {
        dispatch(
          showInfo(`Aliased ${aliasCostume.name} with ${preferredCostume.name}`)
        );
      })
      .catch((response) => {
        dispatch(
          showError(
            `Error aliasing ${aliasCostume.name} with ${preferredCostume.name}`
          )
        );
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function unaliasCostume(filmId, aliasCostume, preferredCostume) {
  return (dispatch) => {
    dispatch({
      type: SAVE_UNALIAS_COSTUME,
      payload: getApiClient().put(
        `${url}/${filmId}/costume/${preferredCostume.id}/RemoveAlias`,
        { aliasId: aliasCostume.id }
      ),
      meta: { aliasCostume, preferredCostume }
    })
      .then((response) => {
        dispatch(
          showInfo(
            `Removed alias ${aliasCostume.name} from ${preferredCostume.name}`
          )
        );
      })
      .catch((response) => {
        dispatch(
          showError(
            `Error removing alias ${aliasCostume.name} from ${preferredCostume.name}`
          )
        );
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function deleteMultipleCostumes(filmId, costumeIds) {
  return (dispatch) => {
    dispatch({
      type: DELETE_MULTIPLE_COSTUMES,
      payload: getApiClient().post(`${url}/${filmId}/Costume/deleteMultiple`, { costumeIds }),
      meta: { costumeIds }
    })
      .then((response) => {
        dispatch(showInfo(`Deleted ${costumeIds.length} costume${costumeIds.length !== 1 ? 's' : ''}`));
      })
      .catch((response) => {
        dispatch(showError(`Error deleting costumes`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}